angular.module("avant.customer_applications.factories").factory "AmountHelper", ->

  notNull = (value) ->
    return false if typeof value is 'undefined'
    return false if value == null
    return false if typeof value is 'string' and value.trim() is ''
    true

  spinnerLoadingMessage = (config, currentStage) ->
    if stageOverrideMessage = config?.stage_transition_loading_message_overrides?[currentStage]
      stageOverrideMessage
    else if defaultMessage = config?.stage_transition_loading_message_default
      defaultMessage
    else
      "Saving your application"

  return {
    notNull: notNull
    spinnerLoadingMessage: spinnerLoadingMessage
  }
